import React from 'react';
import { injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import SubCategoryList from '../../../components/SubCategory/SubCategoryList/SubCategoryList';
import Loader from '../../../components/Common/Loader/Loader';
import messages from '../../../locale/messages';
import { getAllSubCategoryQuery } from '../../../lib/graphql';
import { withQuery } from '../../../hoc/withGraphql';
class SubCategory extends React.Component {

  render() {
    const { formatMessage } = this.props.intl;
    const { subCategoryDetails, subCategoryDetails: { loading } } = this.props;
    return (
      <Loader type={"page"} show={loading}>
        <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.subCategoryMenu)}</h1>
        {!loading && <SubCategoryList subCategoryDetails={subCategoryDetails} />}
      </Loader>
    );
  }
}

export default compose(
  injectIntl,
  withQuery(getAllSubCategoryQuery, {
    name: 'subCategoryDetails',
    options: {
      variables: {
        currentPage: 1,
        searchList: ''
      },
      fetchPolicy: 'network-only',
      ssr: false
    }
  }),
)(SubCategory);
